import styled from "styled-components";

import "../../index.scss";
import "../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div`
	height: 100%;
	background: var(--neutral-stronger);

	width: 50%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;

	@media only screen and (max-width: 900px) {
		width: 100%;
		background: var(--neutral-strongest);
	}
`;

export const Content = styled.section`
	max-width: 27rem;
	height: 100%;
	z-index: 1000;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	font-family: "MetropolisRegular";
	gap: 1.5rem;

	@media only screen and (max-width: 900px) {
		position: relative;
		max-width: 23rem;
		height: 90%;
		justify-content: flex-start;
	}

	form {
		opacity: 1;
		width: 100%;
		max-width: 27rem;
		padding: 30px 0;
	}
`;

export const Title = styled.span`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
`;

export const Subtitle = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: "MetropolisRegular";
	line-height: 150%;
	font-weight: 600;
`;

export const Col = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
`;

export const ContainerPinCode = styled.div`
	padding-top: 13px;
	width: 100%;

	@media only screen and (max-width: 900px) {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
	}
`;

export const MessageError = styled.span`
	width: 100% !important;
	color: var(--feedback-error);
	font-size: var(--font-size-small);
	font-family: var(--font-family-metropolis);
	font-weight: 600;
	margin: 0.3rem 0;
`;

export const ButtonContainer = styled.div`
	margin-top: 40px;
	width: 100%;
`;

export const TextResend = styled.label`
	font-size: 16px;
	font-family: "MetropolisRegular";
	color: #ffffff;
	margin-bottom: 0.5rem;
`;

export const ContentButton = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "centered",
})`
	display: flex;
	justify-content: ${(props) => (props.centered ? "center" : "space-between")};
	font-family: var(--font-family-metropolis-semi-bold);
	gap: 1rem;
`;

export const Timer = styled.div`
	display: flex;
	justify-content: center;
	font-family: "MetropolisRegular";
	margin-top: 48px;
	width: 100%;

	span {
		color: #01e59b;
		font-size: 16px;
	}
`;
